module.exports = __webpack_public_path__ + "img/jinbi_3.bfda3230.png";